import TypedSelect from 'common/ui/TypedSelect';
import Commodity from 'domain/commodity';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface AddCommodityModalProps {
    commodities: Commodity[];
    onAdd(commodity: Commodity): void;
    onHide(): void;
}

const AddCommodityModal: React.FC<AddCommodityModalProps> = props => {
    const [selected, setSelected] = useState<Commodity>(null);

    function onAdd() {
        props.onAdd(selected);
        setSelected(null);
    }

    if (props.commodities == null) return;

    return <Modal show onHide={props.onHide} backdrop="static" size="sm">
        <Modal.Header closeButton>
            <Modal.Title>
                Add Commodity
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <TypedSelect
                options={props.commodities}
                value={selected}
                showNullRow
                textGetter={m => m.displayName}
                valueGetter={m => m.id}
                onValueSelected={setSelected}
                />
        </Modal.Body>
        <Modal.Footer>
            <div className="pull-right">
                <Button variant="secondary" className="ml-2" onClick={props.onHide}>
                    Cancel
                </Button>&nbsp;
                <Button variant="primary" onClick={onAdd} disabled={selected == null}>
                    Add
                </Button>
            </div>
        </Modal.Footer>
    </Modal>;
}

export default AddCommodityModal;